import { useMutation, useQueryClient } from '@tanstack/react-query'

import { patchRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

import { enterpriseMembership } from '../queries/enterprise'
import type { EnterpriseInvitation, EnterpriseInvitationStatus } from '../schemas/enterprise'

export type UpdateEnterpriseInvitationStatusRequest = {
  status: EnterpriseInvitationStatus
}

export type UpdateEnterpriseInvitationStatusParams = {
  invitationId: number | string
  status: EnterpriseInvitationStatus
}

const makeEnterpriseInvitationDecision = async ({ invitationId, status }: UpdateEnterpriseInvitationStatusParams) => {
  try {
    const response = await patchRequest<EnterpriseInvitation>(`/enterprise/invitations/${invitationId}/decision`, {
      status,
    })

    if (!response) return null

    return response
  } catch (error) {
    console.error('Error making enterprise invitation decision', error)
    throw error
  }
}

export const useMakeEnterpriseInvitationDecision = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: makeEnterpriseInvitationDecision,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: queries.users.me.queryKey })
      queryClient.invalidateQueries({ queryKey: enterpriseMembership.info.queryKey })
      queryClient.invalidateQueries({ queryKey: enterpriseMembership.receivedInvitations.queryKey })
      queryClient.invalidateQueries({
        queryKey: enterpriseMembership.invitationById(variables.invitationId).queryKey,
      })
    },
  })
}
